import { CATEGORY_LIST, getCategoryById } from '../utils/categories.js';

/**
 * Render filter controls inside the sidebar.
 */
export function initFilters(container, onFilterChange) {
  container.innerHTML = `
    <div class="filter-group">
      <label>Категории</label>
      <div class="category-filters" id="category-filters"></div>
    </div>
    <div class="filter-group">
      <label>Статус</label>
      <div class="category-filters" id="status-filters">
        <button class="cat-chip active" data-status="all"
          style="--cat-color:#6366f1;--cat-bg:rgba(99,102,241,0.15)">
          <span class="dot" style="background:#6366f1"></span> Все
        </button>
        <button class="cat-chip" data-status="open"
          style="--cat-color:#ef4444;--cat-bg:rgba(239,68,68,0.15)">
          <span class="dot" style="background:#ef4444"></span> Открыто
        </button>
        <button class="cat-chip" data-status="in_progress"
          style="--cat-color:#eab308;--cat-bg:rgba(234,179,8,0.15)">
          <span class="dot" style="background:#eab308"></span> В процессе
        </button>
        <button class="cat-chip" data-status="resolved"
          style="--cat-color:#22c55e;--cat-bg:rgba(34,197,94,0.15)">
          <span class="dot" style="background:#22c55e"></span> Решено
        </button>
      </div>
    </div>
    <div class="filter-group">
      <label>Период</label>
      <div class="date-filters">
        <input type="date" id="filter-date-from" placeholder="С">
        <input type="date" id="filter-date-to" placeholder="По">
      </div>
    </div>
  `;

  // Render category chips
  const catContainer = document.getElementById('category-filters');
  CATEGORY_LIST.forEach((cat) => {
    const chip = document.createElement('button');
    chip.className = 'cat-chip active';
    chip.dataset.category = cat.id;
    chip.style.setProperty('--cat-color', cat.color);
    chip.style.setProperty('--cat-bg', cat.colorLight);
    chip.innerHTML = `<span class="dot" style="background:${cat.color}"></span> ${cat.name}`;
    chip.addEventListener('click', () => {
      chip.classList.toggle('active');
      onFilterChange(getActiveFilters());
    });
    catContainer.appendChild(chip);
  });

  // Status filter clicks
  const statusContainer = document.getElementById('status-filters');
  statusContainer.querySelectorAll('.cat-chip').forEach((btn) => {
    btn.addEventListener('click', () => {
      statusContainer.querySelectorAll('.cat-chip').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      onFilterChange(getActiveFilters());
    });
  });

  // Date filter changes
  const dateFrom = document.getElementById('filter-date-from');
  const dateTo = document.getElementById('filter-date-to');
  dateFrom.addEventListener('change', () => onFilterChange(getActiveFilters()));
  dateTo.addEventListener('change', () => onFilterChange(getActiveFilters()));
}

export function getActiveFilters() {
  const categories = Array.from(
    document.querySelectorAll('#category-filters .cat-chip.active')
  ).map((c) => c.dataset.category);

  const statusBtn = document.querySelector('#status-filters .cat-chip.active');
  const status = statusBtn?.dataset.status === 'all' ? null : statusBtn?.dataset.status;

  const keyword = document.getElementById('search-input')?.value?.trim() || '';
  
  const dateFrom = document.getElementById('filter-date-from')?.value || null;
  const dateTo = document.getElementById('filter-date-to')?.value || null;

  return { categories, status, keyword, dateFrom, dateTo };
}
